import React from 'react'
import MainLayout from '../components/MainLayout'
import { useTranslation } from 'react-i18next';

const ApplicationsPage = () => {
    const { t } = useTranslation();

    const ApplicactionData = t('applications.list');

    return (
        <MainLayout>
            <div className='position-relative'>
                <div className='container app-container-spacing text-white'>
                    <p className='fs-48 fw-bold text-center'>{t("applications.title-app")}</p>
                    <div>
                        {
                            ApplicactionData.map((item, index) => {
                                return (
                                    <ApplicactionContent key={index} {...item} index={index} />
                                )
                            })
                        }
                    </div>
                </div>
            </div>
        </MainLayout>
    )
}

const ApplicactionContent = ({ title, imgUrl, subtitle, description, hash, index }) => {

    return (
        <div id={hash}>
            <div className='app-item-spacing mx-3 mx-xl-5'>
                <div
                    className='row d-flex flex-column flex-xl-row justify-content-center align-items-center g-0'
                >
                    {
                        index % 2 === 0 &&
                        <ApplicationCard data={{ title, imgUrl, subtitle, justifyItem: 'start' }} />
                    }
                    <div className="col d-none d-xl-block">
                        <p className='fw-regular fs-24 my-4 my-xl-2 text-justify'>
                            {description}
                        </p>
                    </div>
                    {
                        index % 2 !== 0 &&
                        <ApplicationCard data={{ title, imgUrl, subtitle, justifyItem: 'end' }} />
                    }
                    <div className="col d-xl-none">
                        <p className='fw-regular fs-24 my-4 my-xl-2'>
                            {description}
                        </p>
                    </div>
                </div>
            </div>
        </div>
    )
}

const ApplicationCard = ({ data }) => {
    const { title, imgUrl, subtitle, justifyItem } = data;
    const appImg = {
        borderRadius: "15px",
        height: "200px",
        width: "200px",
        background: "rgba(195, 195, 195, 0.16)",
    }
    return (
        <div className="col col-xl-4">
            <div className={`d-flex justify-content-center justify-content-xl-${justifyItem}`}>
                <div
                    className='card py-4'
                    style={appImg}
                >
                    <div className="d-flex justify-content-center align-items-center pt-3">
                        <div className="learn-5g-img-border d-flex justify-content-center align-items-center">
                            <img src={`${process.env.PUBLIC_URL}/images/applications/${imgUrl}`} alt={title} className="img-fluid" style={{ height: '48px', width: 'auto' }} />
                        </div>
                    </div>
                    <p className='text-center fw-medium fs-22'>{title}</p>
                    <p className='text-center'>{subtitle}</p>
                </div>
            </div>
        </div>
    )
}

export default ApplicationsPage